module.exports = __webpack_public_path__ + "static/media/ic-search.9b51ec00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NoResults/ic-search.svg
// module id = 1067
// module chunks = 0